import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import { getBaseName } from 'helpers/AppHelper';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';

import './LightBox.scss'


class LightBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }



    componentDidUpdate(prev) {

    }

    componentDidMount() {

    }


    render() {
        return (
            <div className="LightBox">

            </div>)

    }
}


const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(LightBox)));


